export const DEFAULT_QUICK_REPORT_TEMPLATE_CODE = 'growth_pulse';

/** TODO(overview-pdf-be): použiť pri create overview reportu keď BE pridá template. */
export const OVERVIEW_REPORT_TEMPLATE_CODE = 'overview';

export type QuickReportScope = 'full' | 'performance' | 'overview';
